import styled from "styled-components";

import Colors from "../../settings/colors";
import Metrics from "../../settings/metrics";
import Fonts from "../../settings/fonts";

export const Container = styled.div`
  overflow: hidden;
  margin-bottom: 40px;
  padding: ${Metrics.spaceXs};
`;

export const Header = styled.div`
  display: flex;

  > h1 {
    color: ${Colors.lightBlue};
    font-size: ${Fonts.titleXl};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-left: ${Metrics.spaceXl};

  > button {
    margin-right: ${Metrics.spaceLg};

    @media (max-width: 758px) {
      margin-right: 0;
      margin-top: ${Metrics.spaceSm};
    }
  }

  @media (max-width: 758px) {
    margin-left: 0;
    max-width: 400px;
    width: 100%;
    flex-direction: column;
  }
`;

export const TabNavigation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin-top: ${Metrics.space};
`;
